import { createDataFetchSlice } from '../../../../utils/dataFetch';


export const adminAccountStatisticChargesExcelSlice = createDataFetchSlice<
    { data: string }
>({ name: 'chargesExcel' });
